import {Component, OnInit, Input} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DownloadService} from '../../services/download/download';
import * as fileSaver from 'file-saver';
import { AlertService } from 'src/app/services/alert/alert.service';
import { HttpClient } from '@angular/common/http';
import {GridOptions, ColDef, ColGroupDef, GridApi} from 'ag-grid-community';
import {ActivatedRoute} from '@angular/router';
import { DownloadAnchorTagComponent } from './download-file.component';


@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.css'],
    standalone: false
})
  export class DownloadComponent implements OnInit {


      constructor(private downloadService: DownloadService,
        private fb: UntypedFormBuilder, private http: HttpClient,
        private alertService: AlertService,
        private route: ActivatedRoute, ) {
          this.domLayout = 'autoHeight';
          this.paginationPageSize = 10;
          this.downloadForm = this.fb.group({
          fileType: new UntypedFormControl(null, Validators.required),
          scacCode: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
          });
      }
    @Input() externalTitle: any;
    showBusinessType: Boolean;
    title: String = 'File Downloads';
    types: any[] = [
        {value: 'hhg', name: 'HHG Rate File'},
        {value: 'frt', name: 'FRT Rate File'},
        {value: 'shipment', name: 'Shipment file'},
        {value: 'survey', name: 'Survey file'},
      ];
      gridOptions: GridOptions = this.initializeGridOptions();
      fileDownload = {status: '', message: ''};
      downloadForm: UntypedFormGroup;
      showHHGRateFiles: Boolean = false;
      showScacFiles: Boolean = false;
      sysAdmin: Boolean = false;
      domLayout: any;
      paginationPageSize: any;
      fileNameSelected: any;
      private gridApi!: GridApi<any>;
      scacCode: any;
      downloadFileList: any;
      getRowHeight(params) {
        return 35;
      }
      downloadFileListColumnDefs(): (ColDef | ColGroupDef)[] {
        return [
          <ColDef>
        { headerName: 'Module Name', field: 'moduleName'},
        { headerName: 'File Name', field: 'fileName' },
        { headerName: 'Creation Date', field: 'lastModified'},
        { headerName: 'Size', field: 'fileSize'},
        {
          headerName: 'Download',
          cellRenderer: DownloadAnchorTagComponent,
          cellRendererParams: {
            onClick: this.onDownloadFile.bind(this)
          }
        }
        ];
      }

      private initializeGridOptions() {
        return <GridOptions>{
          columnDefs: this.downloadFileListColumnDefs(),
          context: {parentComponent: this},
          rowSelection: 'single',
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressAndOrCondition: true
            }
          },
          headerHeight: 50,
          pagination: true,
          paginationPageSize: 25,
          cacheBlockSize: 25,
          rowData : this.downloadFileList,
          domLayout: 'autoHeight',
          suppressDragLeaveHidesColumns: true,
          onGridReady: params => {
            params.api.sizeColumnsToFit();
          },
          overlayLoadingTemplate:
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
          overlayNoRowsTemplate:
            '<span>No files available to download</span>'
        };
      }
      ngOnInit() {
        if (this.externalTitle) {
          this.title = this.externalTitle;
        }
        this.route.queryParams.subscribe(params => {
          const roleId = params['roleId'];
          if (roleId == 7) {
            this.sysAdmin = true;
            this.fileDownload = {status: '', message: ''};
            this.gridOptions.rowData = [];
            this.getDownloadFileslist();
          } else {
            this.sysAdmin = false;
            this.fileDownload = {status: '', message: ''};
            this.getDownloadFileslist();
          }
        });
      }

      onRowClick(event) {
          this.alertService.warn('It may take a couple of minutes before the file is downloaded to your desktop for access.');
          this.fileNameSelected = event.node.data.fileName;
          this.scacCode = this.downloadForm.get('scacCode').value;
          this.downloadService.downloadFile(event.node.data.moduleName, event.node.data.fileName, this.scacCode).subscribe(
            response => {
             // var contentDisposition = response.headers.get('content-disposition');
             // var filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
              fileSaver.saveAs(response, this.fileNameSelected);
              this.alertService.success('Your file has been downloaded successfully.');
            },
            error => {
              console.log(error);
              this.fileDownload = {status: 'error', message: error.name + ': ' + error.message};
              this.alertService.error('Your file downloaded is failed. Please try again');
            }
          );
      }

      onGridReady(params) {
        this.gridApi = params.api;
      }

      getFiles() {
          this.downloadService.downloadFileForSysAdmin(this.downloadForm.get('scacCode').value).subscribe(
          response => {
            this.showScacFiles = true;
            this.gridApi.setGridOption('rowData', response);
          },
          error => {
            console.log(error);
            this.fileDownload = {status: 'error', message: error.name + ': ' + error.message};
          }
        );
      }

      getDownloadFileslist() {
        this.downloadService.getDownloadFilesList().subscribe(
          response => {
            this.showHHGRateFiles  = true;
            this.downloadFileList = response;
            this.gridApi.setGridOption('rowData', this.downloadFileList);
          },
          error => {
            console.log(error);
            this.fileDownload = {status: 'error', message: error.name + ': ' + error.message};
          }
        );
      }

      onDownloadFile(eventObj: any) {
        this.alertService.warn('It may take a couple of minutes before the file is downloaded to your desktop for access.');
        this.fileNameSelected = eventObj.fileName;
        this.scacCode = this.downloadForm.get('scacCode').value;
        this.downloadService.getPresignedUrl(eventObj.moduleName, eventObj.fileName, this.scacCode).subscribe(
          response => {
            window.location.href = response;
          },
          error => {
            console.log(error);
            this.fileDownload = {status: 'error', message: error.name + ': ' + error.message};
            this.alertService.error('Your file downloaded is failed. Please try again');
          }
        );
      }
  }
